import { useEffect, useRef, useState } from 'react';

/**
 * Hook minimal para revelar elementos al entrar en viewport.
 * Añade la clase "in-view" al elemento referenciado.
 */
export function useReveal(options = { threshold: 0.15 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            node.classList.add('in-view');
            setVisible(true);
            observer.unobserve(node);
          }
        });
      },
      options
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { ref, visible };
}
